<h1 *ngIf="!isLoaded && !error" class="px-2 mx-auto">Loading...</h1>
<h1 *ngIf="error" class="px-2 mx-auto text-red-500">{{ error.toString() }}</h1>

<section *ngIf="isLoaded" class="flex flex-col justify-center mx-auto">
  <div class="flex flex-row p-1 m-2 mb-2 text-left border border-gray-800 border-solid">
    <span class="flex-grow bg-gray-800"></span>
    <span class="p-1 ml-1 bg-gray-800 border border-gray-800 border-solid">
      Übersicht aller Subraum-Scans
    </span>
    <label class="px-2 py-1 ml-1 bg-gray-800 border border-gray-800 border-solid">
      Anzahl pro Seite
    </label>
    <input
      class="w-12 px-2 py-1 mr-1 text-center text-black bg-gray-700 border-2 border-gray-500 border-solid focus:border-orange-300"
      type="text"
      name="pageSize"
      [(ngModel)]="pageSize"
      (change)="onPageSizeChange()"
    />
    <button class="px-2 py-1 mr-1 bg-gray-800 border border-white border-solid hover:border-orange-300 hover:text-orange-300" (click)="updatePagination()">
      Anzeigen
    </button>
    <span class="flex-grow bg-gray-800"></span>
  </div>

  <div class="grid grid-cols-1 gap-2 mx-auto">
    <div class="flex flex-row p-1 text-left border border-gray-800 border-solid">
      <button (click)="onFirstPage()" class="px-2 py-1 mr-1 bg-gray-800 border border-white border-solid hover:border-orange-300 hover:text-orange-300">
        Erste
      </button>
      <button (click)="onPreviousPage()" class="px-2 py-1 mr-1 bg-gray-800 border border-white border-solid hover:border-orange-300 hover:text-orange-300">
        Vorherige
      </button>
      <span class="flex-grow bg-gray-800"></span>
      <span class="p-1 mx-1 bg-gray-800 border border-gray-800 border-solid">
        {{ pageCurrent }} / {{ pageMax }}
      </span>
      <span class="flex-grow bg-gray-800"></span>
      <button (click)="onNextPage()" class="px-2 py-1 ml-1 bg-gray-800 border border-white border-solid hover:border-orange-300 hover:text-orange-300">
        Nächste
      </button>
      <button (click)="onLastPage()" class="px-2 py-1 ml-1 bg-gray-800 border border-white border-solid hover:border-orange-300 hover:text-orange-300">
        Letzte
      </button>
    </div>

    <table class="table border-separate border-spacing-1">
      <thead>
        <tr>
          <th (click)="sortPage(SortBy.ID)" class="px-2 bg-gray-800 border border-gray-700 border-solid cursor-pointer hover:text-orange-300">ID</th>
          <th (click)="sortPage(SortBy.POSITION)" class="px-2 bg-gray-800 border border-gray-700 border-solid cursor-pointer hover:text-orange-300">Position</th>
          <th (click)="sortPage(SortBy.OBJECTS)" class="px-2 bg-gray-800 border border-gray-700 border-solid cursor-pointer hover:text-orange-300">Objekte</th>
          <th (click)="sortPage(SortBy.UPDATED_AT)" class="px-2 bg-gray-800 border border-gray-700 border-solid cursor-pointer hover:text-orange-300">Aktualisiert am</th>
          <th (click)="sortPage(SortBy.UPDATED_BY)" class="px-2 bg-gray-800 border border-gray-700 border-solid cursor-pointer hover:text-orange-300">Aktualisiert von</th>
          <th (click)="sortPage(SortBy.CREATED_AT)" class="px-2 bg-gray-800 border border-gray-700 border-solid cursor-pointer hover:text-orange-300">Erstellt am</th>
          <th (click)="sortPage(SortBy.CREATED_BY)" class="px-2 bg-gray-800 border border-gray-700 border-solid cursor-pointer hover:text-orange-300">Erstellt von</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let scan of page">
          <td class="px-2 text-right bg-gray-900 border border-gray-800 border-solid">
            <a [routerLink]="['/scan', scan.id]" class="hover:text-orange-300">{{ scan.id }}</a>
          </td>
          <td class="px-2 text-center bg-gray-900 border border-gray-800 border-solid">{{ scan.x }}|{{ scan.y }}</td>
          <td class="px-2 text-right bg-gray-900 border border-gray-800 border-solid">{{ scan.scanObjects }}</td>
          <td class="px-2 text-right bg-gray-900 border border-gray-800 border-solid">{{ scan.updatedAt | date:'dd.MM.yyyy HH:mm' }}</td>
          <td class="px-2 text-right bg-gray-900 border border-gray-800 border-solid">
            <a [routerLink]="['/admin/user', scan.updatedBy.id]" class="hover:text-orange-300">{{ scan.updatedBy.name }}</a>
          </td>
          <td class="px-2 text-right bg-gray-900 border border-gray-800 border-solid">{{ scan.createdAt | date:'dd.MM.yyyy HH:mm' }}</td>
          <td class="px-2 text-right bg-gray-900 border border-gray-800 border-solid">
            <a [routerLink]="['/admin/user', scan.createdBy.id]" class="hover:text-orange-300">{{ scan.createdBy.name }}</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
